<template>
  <!-- 会员卡管理-领取记录 -->
  <div class="vip_log-box">
    <!-- header头部 -->
    <header>
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item>
          <el-input
            v-model.trim="query.user_id"
            placeholder="请输入用户id"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-input
            v-model.trim="query.card_name"
            placeholder="会员卡名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="领取时间段:">
          <el-date-picker
            v-model="query.created_at_start"
            type="datetime"
            placeholder="开始时间"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
          -
          <el-date-picker
            v-model="query.created_at_end"
            type="datetime"
            placeholder="结束时间"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="失效时间段:">
          <el-date-picker
            v-model="query.failure_time_start"
            type="datetime"
            placeholder="开始时间"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
          -
          <el-date-picker
            v-model="query.failure_time_end"
            type="datetime"
            placeholder="结束时间"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="使用时间段:">
          <el-date-picker
            v-model="query.use_time_start"
            type="datetime"
            placeholder="开始时间"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
          -
          <el-date-picker
            v-model="query.use_time_end"
            type="datetime"
            placeholder="结束时间"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getData(1)">搜索</el-button>
        </el-form-item>
      </el-form>
    </header>
    <!-- body内容 -->
    <div class="body-box">
      <el-table
        :data="dataList"
        v-loading="loading"
        style="margin-bottom: 20px"
      >
        <el-table-column prop="user_id" label="用户id" align="center">
        </el-table-column>
        <el-table-column prop="name" label="会员卡名字" align="center">
          <template slot-scope="{ row }">
            <span>{{
              row.member_card_user && row.member_card_user.member_card.name
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="receive_amount"
          label="金额"
          align="center"
          sortable
        >
        </el-table-column>
        <el-table-column
          prop="created_at"
          label="领取时间"
          align="center"
          sortable
        >
        </el-table-column>
        <el-table-column prop="failure_time" label="失效时间" align="center">
        </el-table-column>
        <el-table-column prop="use_amount" label="使用金额" align="center">
        </el-table-column>
        <el-table-column prop="use_time" label="使用时间" align="center">
        </el-table-column>
        <el-table-column prop="status" label="状态" align="center">
          <template slot-scope="{ row }">
            <el-tag v-if="row.status === 1">未使用</el-tag>
            <el-tag type="success" v-if="row.status === 2">使用中</el-tag>
            <el-tag type="info" v-if="row.status === 3">已失效</el-tag>
            <el-tag type="danger" v-if="row.status === 4">已用完</el-tag>
            <el-tag type="danger" v-if="row.status === 5">清除</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="来源" align="center">
          <template slot-scope="{ row }">
            <span v-if="row.type === 1">用户领取</span>
            <span v-if="row.type === 2">后台赠送</span>
          </template>
        </el-table-column>
        <!-- <el-table-column
          label="操作"
          width="300px"
          align="center"
          fixed="right"
        >
          <template slot-scope="{ row }">
            <el-button type="primary" size="small" @click="deleteEvent(row)"
              >删除</el-button
            >
          </template>
        </el-table-column> -->
      </el-table>

      <!-- 底部分页条 -->
      <el-pagination
        class="underBar"
        background
        :page-size="dataMeta.per_page || 15"
        :total="dataMeta.total || 0"
        :current-page="dataMeta.current_page || 15"
        @current-change="handlePageChange"
        v-if="dataMeta && dataMeta.total > dataMeta.per_page"
      ></el-pagination>
    </div>

    <!-- 弹窗 -->
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import http, { server, api, delApiData, getApiData, postApiData, patchApiData } from '@/http'
import saveFile from '@/utils/saveFile'

export default {
  name: 'vip_log',
  components: {
  },
  data() {
    return {
      detailsVisible: false,//用户详情信息显示标志
      loading: false,//加载动画
      buttonLoading: false,//按钮加载动画
      dialogLoading: false,//弹窗加载数据动画
      query: {//查询条件
        page: 1,
        user_id: undefined,//用户id
        card_name: undefined,//会员卡名称
        created_at_start: undefined,//领取开始时间
        created_at_end: undefined,//领取结束时间
        failure_time_start: undefined,//失效开始时间
        failure_time_end: undefined,//失效结束时间
        use_time_start: undefined,//使用开始时间
        use_time_end: undefined,//使用结束时间
      },
      dialogInfo: undefined,//要传递的弹窗数据
      dataList: undefined,//列表数据
      dataMeta: undefined,//底部跳转页面条
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData(num) {
      if (num === 1) {
        this.query.page = 1
      }
      this.loading = true
      let params = this.query
      getApiData('member_card_receive_record', params).then(res => {
        if (res) {
          this.dataList = res.data
          //设置底部导航条数据
          this.dataMeta = {
            current_page: res.current_page,//当前页标
            per_page: res.per_page,//每页多少条
            total: res.total,//总数据条数
            total_pages: res.total_pages,//总页数
          }
        }
      }).finally(() => {
        this.loading = false
      })
    },
    openMsgDialog(rowInfo) {
      //打开详情页面
      this.detailsVisible = true
      this.dialogInfo = JSON.parse(JSON.stringify(rowInfo))
    },
    handlePageChange(page) {
      //页面底部跳转页面
      this.query.page = page
      this.getData()
    },
  },
}
</script>

<style lang="less" scoped>
.vip_log-box {
  header {
  }

  .body-box {
  }
}
</style>